/**
 * Conditional className joiner.
 *
 * Hand-rolled instead of pulling in clsx: it is four lines, and this project
 * deliberately owns its primitives. It does NOT merge conflicting Tailwind
 * classes (no tailwind-merge) — primitives here are written so that the caller's
 * className is appended last and wins by CSS order, which is enough for the
 * variants we have and keeps the mental model simple.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values
    .filter(
      (value): value is string | number =>
        value !== false && value !== null && value !== undefined && value !== '',
    )
    .join(' ');
}
